import { memo, useEffect } from "react";

import { Route, Routes } from "react-router-dom";
import { LoadingShim } from "@narmi/design_system";
import { modules } from "byzantine";
import { type WireType } from "byzantine/src/dbbl/businessLogic/modules/internationalWires";

import SendViaTemplate from "./SendViaTemplate";

const WireTemplatesScreen = memo(function WireTemplatesScreen({
  setWireType,
  wireType,
}: {
  setWireType: (wireType: WireType) => void;
  wireType: WireType;
}) {
  const { loading, load } = modules.wireTemplates.bootstrap.useBootstrap();
  useEffect(() => {
    load();
  }, [load]);

  if (loading) {
    return (
      <LoadingShim isLoading>
        <div style={{ height: "100vh" }} />
      </LoadingShim>
    );
  }
  return (
    <Routes>
      <Route
        index
        element={
          <SendViaTemplate setWireType={setWireType} wireType={wireType} />
        }
      />
    </Routes>
  );
});

export default WireTemplatesScreen;
